import React from 'react'
import Table from '../creditcard/Table'

import ReactMarkdown from 'react-markdown'

import MarkdownHelper from '../../utils/MarkdownHelper'

import Flag from '../../subcomponents/Flag'
import ContentBox from '../../subcomponents/ContentBox'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";
import { ProcessSteps, transformProcessSteps } from './ProcessStep'

const OfferPage = ({
    campaign,
    image,
    bigIndices,
    footnotesWarningText,
    partnerLogo,
    flagFilter,
    logoFilter,
    isMobile,
}) => {
    const processContainerSteps = transformProcessSteps(campaign)

    let table = Object.fromEntries(Object.entries(campaign).filter(([key]) => key.includes('table_')))

    const tags = 'Airlines, Lufthansa'

    const hasTable = Object.keys(table).length > 0

    const termsAndConditions = (
        <div className="terms-and-conditions">
            <div className="header">
                <div className="headline">
                    <ReactMarkdown
                        {...MarkdownHelper.allTypes()}
                        source={MarkdownHelper.parse(campaign.terms_and_conditions_title)}
                    />
                </div>
            </div>
            <ReactMarkdown
                {...MarkdownHelper.allTypes()}
                source={MarkdownHelper.parse(campaign.terms_and_conditions)}
            />
        </div>
    )

    return (
        <div className="mam3-type offer-page border">
            <ContentBox campaign={campaign} logo={logoFilter.includes('Web Logo verbergen') ? '' : partnerLogo}>
                {campaign.title_3_long}
            </ContentBox>

            {image && (
                <div className="hero-wrapper">
                    {['Alle', 'Web'].some(val => flagFilter.includes(val)) &&
                        <Flag text={campaign.flagstoerer} appearance={campaign.flageye_catcher} />
                    }

                    <img src={image} className="hero img-fluid" role="presentation" alt="Offer Page" />
                </div>
            )}

            <div className="content">
                <div className="keyfacts js-mam-symbol-content">
                    <span className="headline">
                        <ReactMarkdown
                            {...MarkdownHelper.keyfactsTypes()}
                            source={MarkdownHelper.parse(campaign.main_benefit_offerpage)}
                            escapeHtml={false}
                        />
                    </span>

                    <div className="benefits">
                        <ReactMarkdown {...MarkdownHelper.keyfactsTypes()}
                            source={MarkdownHelper.parse(campaign.key_facts_web)}
                            escapeHtml={false}
                        />
                    </div>

                    <button>{campaign.button_cta_external}</button>
                </div>

                <div className="other">
                    <div className="copy-long">
                        <ReactMarkdown {...MarkdownHelper.allTypes()} source={MarkdownHelper.parse(campaign.copy_long)} />
                    </div>
                </div>
            </div>

            <div className="process-wrapper">
                <div className={["process-content", isMobile('web') ? "mobile" : ""].join(' ')}>
                    {(processContainerSteps.length !== 0) && (
                        <div className="process">
                            <span className="headline">
                                <ReactMarkdown
                                    {...MarkdownHelper.headingTypes()}
                                    escapeHtml={false}
                                    source={MarkdownHelper.parse(campaign.process_container_headline)}
                                />
                            </span>

                            <ProcessSteps
                                isMobile={isMobile('web')}
                                steps={processContainerSteps}
                                behavior='stack'
                            />
                        </div>
                    )}

                    {campaign.terms_and_conditions && !hasTable && termsAndConditions}

                    {!hasTable && (
                        <div className="disclaimer">
                            <FootnotesFromContext showWarningText={footnotesWarningText} bigIndices={bigIndices} />
                        </div>
                    )}

                    {tags && !hasTable && (
                        <ul className="tags">
                            {tags.split(',').map((tag, i) => <li key={i}>#{tag.trim()}</li>)}
                        </ul>
                    )}
                </div>
            </div>


            {hasTable && (
                <div className="table-container">
                    <Table table={table}/>
                    {campaign.terms_and_conditions && termsAndConditions}
                    <div className="disclaimer">
                        <FootnotesFromContext showWarningText={footnotesWarningText} />
                    </div>

                    {tags && (
                        <ul className="tags">
                            {tags.split(',').map((tag, i) => <li key={i}>#{tag.trim()}</li>)}
                        </ul>
                    )}
                </div>
                )}
        </div>
    )
}

export default OfferPage



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferPage.js